import { ApiEndpoints } from "../core";
import { httpClient } from "../core";
import {
  addGymScheduleState,
  addGymState,
  changeGymLoading,
  deleteGymScheduleState,
  deleteGymState,
  dispatch,
  editgymState,
  setErrorMessage,
  setGymById,
  setGymState,
  setScheduleGymState,
  setSuccessMessage,
} from "../redux";

export const getGym = async (refresh = false, page,limit,search="",sort) => {
  try {
    // Set Loading if it is not refresh
    if (!refresh) dispatch(changeGymLoading(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.getGyms, {
      params: {
        page,
        limit,
        name:search,
        sort
      },
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setGymState({ gyms: resp.data.results, refresh }));

    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.results;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeGymLoading(false));
  }
};

export const addGym = async (gymdata) => {
  try {
    // Set Loading
    dispatch(changeGymLoading(true));

    // API Fetching
    const resp = await httpClient().post(ApiEndpoints.createGym, {
      ...gymdata,
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(addGymState(resp.data.results));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeGymLoading(false));
  }
};

export const getGymById = async (id) => {
  try {
    // Set Loading
    dispatch(changeGymLoading(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.gymById + "/" + id);

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setGymById(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.result;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeGymLoading(false));
  }
};

export const editGym = async (id, gymData) => {
  try {
    // Set Loading
    dispatch(changeGymLoading(true));

    // API Fetching
    const resp = await httpClient().patch(
      ApiEndpoints.editGym + "/" + id,
      gymData
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(editgymState(resp.data.result));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeGymLoading(false));
  }
};

export const deleteGym = async (id) => {  
  try {
    // Set Loading
    dispatch(changeGymLoading(true));

    // API Fetching
    const resp = await httpClient().delete(ApiEndpoints.gymDelete + "/" + id);
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(deleteGymState(id));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeGymLoading(false));
  }
};

export const addGymSchedule = async (gym, session, date) => {
  try {
    // Set Loading
    dispatch(changeGymLoading(true));

    // API Fetching
    const resp = await httpClient().post(ApiEndpoints.addGymSchedule, {
      gym,
      session,
      date,
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(addGymScheduleState(resp.data.result));
    dispatch(setSuccessMessage(resp.data.message));
    return resp.data.result;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeGymLoading(false));
  }
};

export const deleteGymSchedule = async (id) => {
  try {
    // Set Loading
    dispatch(changeGymLoading(true));

    // API Fetching
    const resp = await httpClient().delete(
      ApiEndpoints.deleteGymSchedule + "/" + id
    );
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(deleteGymScheduleState(id));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeGymLoading(false));
  }
};

export const getScheduleGym = async (refresh = false, gym) => {
  try {
    // Set Loading if it is not refresh
    if (!refresh) dispatch(changeGymLoading(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.getScheduleGym, {
      params: {
        gym,
        limit: -1,
      },
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setScheduleGymState({ schedules: resp.data.results, refresh }));

    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeGymLoading(false));
  }
};

export const duplicateScheduleApi = async (id, selectedGyms, override) => {

  try {
    // Set Loading
    dispatch(changeGymLoading(true));

    // API Fetching
    const resp = await httpClient().post(
      ApiEndpoints.duplicateSchedule + "/" + id,
      {
        gymIds: selectedGyms,
        override: override,
      }
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeGymLoading(false));
  }
};
